<template>
  <a-modal
    :maskClosable="false"
    :title="modalTitle"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    :okButtonProps="{ props: { disabled: disabled } }"
    @ok="handleSubmit"
    @cancel="visible = false"
  >
    <a-form layout="horizontal" :form="form" @submit="handleSubmit">
      <a-form-item
        label="广告标题"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          v-decorator="['title', { rules: [{ required: true, message: '请输入活动标题' }] }]"
          :disabled="disabled"
        />
      </a-form-item>

      <a-form-item label="类型" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
        <a-select
          class="form-cell"
          placeholder="请选择广告类型"
          :disabled="disabled"
          @change="clickTypeChange"
          v-decorator="[
            'clickType',
            { initialValue: clickType },
            { rules: [{ required: true, message: '请选择广告类型' }] },
          ]"
        >
          <a-select-option :value="1">H5页面</a-select-option>
          <a-select-option :value="2">活动</a-select-option>
          <a-select-option :value="3">班级</a-select-option>
          <a-select-option :value="4">资讯</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        v-if="clickType == 1"
        label="H5页面"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="H5页面地址"
          :disabled="disabled"
          v-decorator="['h5Url', { rules: [{ required: true, message: '请填写H5页面地址' }] }]"
        />
      </a-form-item>

      <a-form-item
        v-if="clickType != 1"
        :label="clickTypeStr[clickType - 1] + 'ID'"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          :placeholder="'请填写' + clickTypeStr[clickType - 1] + 'ID'"
          :disabled="disabled"
          v-decorator="[
            'clickParam',
            { rules: [{ required: true, message: '请填写' + clickTypeStr[clickType - 1] + 'ID' }] },
          ]"
        />
      </a-form-item>

      <a-form-item
        v-if="roleId == 1"
        label="展示区域"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-radio-group name="radioGroup" :defaultValue="1" v-model="showType">
          <a-radio :value="1">教育局</a-radio>
          <a-radio :value="2">学校</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        v-if="roleId == 1 && showType == 2"
        label="展示学校"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <!-- <a-input
          type="text"
          :placeholder="'请填写学校ID'"
          :disabled="disabled"
          v-decorator="[
                'schoolId',
                {rules: [{ required: true, message: '请填写学校ID' }]}
              ]"
        />-->
        <a-select
          :showSearch="true"
          :showArrow="false"
          labelInValue
          placeholder="搜索学校"
          style="width: 100%"
          :filterOption="false"
          @search="fetch"
          @change="searchChange"
          :notFoundContent="fetching ? undefined : null"
          v-decorator="['schoolId', { rules: [{ required: true, message: '请选择学校' }] }]"
        >
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in data" :key="d.value" :value="d.value">{{
            d.text
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="广告图"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        :required="true"
        :help="bannerHelpTxt"
        validateStatus="error"
      >
        <c-upload
          ref="imgUrl"
          :ossType="'banner'"
          :isSingle="true"
          @uploadSuccess="uploadSuccess"
        ></c-upload>
      </a-form-item>

      <a-form-item
        label="优先级"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input-number
          :min="0"
          :disabled="disabled"
          v-decorator="[
            'priority',
            { initialValue: 0 },
            { rules: [{ required: false, min: 0, message: '优先级' }] },
          ]"
        />&emsp;数字越大越靠前显示
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import banner from '../../api/banner'
import notification from 'ant-design-vue/es/notification'
import CUpload from '../../components/CUpload/CUpload'

export default {
  name: 'bannerForm',
  components: { CUpload },
  data() {
    return {
      roleId: 0,
      modalTitle: '',
      type: '',
      id: -1,
      visible: false,
      confirmLoading: false,
      disabled: false, //是否禁止编辑
      clickType: 1,
      clickTypeStr: ['h5页面', '活动', '班级', '资讯'],
      imgUrl: '', //Banner图片地址
      bannerHelpTxt: '',
      showType: 1,
      data: [],
      value: [],
      fetching: false,
    }
  },
  methods: {
    clickTypeChange(value) {
      this.clickType = value
    },
    fetch(value) {
      console.log('fetching', value)
      this.data = []
      this.fetching = true
      let schoolName = value
      banner.searchSchool({ schoolName }).then(res => {
        const data = res.data.map(item => ({
          text: item.schoolName,
          value: item.id + '',
        }))
        console.log(data)
        this.data = data
        this.fetching = false
      })
    },
    searchChange(value) {
      Object.assign(this, {
        value,
        data: [],
        fetching: false,
      })
    },
    //初始化，显示
    init(type, params) {
      this.id = params.id
      this.type = type
      this.visible = true
      let id = this.id
      //获取详情
      if (this.type == 'add') {
        this.disabled = false
        this.modalTitle = '新增广告'
        this.form.resetFields()
        setTimeout(() => {
          this.$refs.imgUrl.imageUrl = ''
        }, 100)
      }
      //获取详情
      if (this.type == 'edit') {
        this.disabled = false
        this.modalTitle = '修改广告'
        this.getDetail(id)
      }
    },
    //提交
    handleSubmit(e) {
      console.log('img', this.imgUrl)
      e.preventDefault()
      if (this.imgUrl == '') {
        this.bannerHelpTxt = '请上传广告图片'
      }
      this.form.validateFields((err, values) => {
        console.log('v', values)
        //校验通过
        if (!err && this.bannerHelpTxt == '') {
          let newValues = {
            title: values.title ? values.title : '',
            imgUrl: this.imgUrl,
            clickType: values.clickType ? values.clickType : '',
            priority: values.priority,
          }
          //代理
          if (this.roleId == 1) {
            if (this.showType == 1) {
              newValues.bureauId = this.$ls.get('bureauId')
              newValues.schoolId = ''
            }
            if (this.showType == 2) {
              newValues.bureauId = ''
              newValues.schoolId = values.schoolId.key
            }
          }
          //平台
          if (this.roleId == 6) {
            newValues.schoolId = ''
            newValues.bureauId = ''
          }
          //教育局
          if (this.roleId == 2) {
            newValues.schoolId = ''
            newValues.bureauId = this.$ls.get('bureauId')
          }
          //学校
          if (this.roleId == 3) {
            newValues.schoolId = this.userInfo.schoolId
            newValues.bureauId = ''
          }

          if (values.clickType == 1 && values.h5Url && values.h5Url != '') {
            newValues.h5Url = values.h5Url
          }
          if (values.clickType != 1 && values.clickParam && values.clickParam != '') {
            newValues.clickParam = values.clickParam
          }
          if (this.type == 'add') {
            //  console.log(newValues);
            this.add(newValues)
          }
          if (this.type == 'edit') {
            this.edit(newValues)
          }
        }
      })
    },
    //新增
    add(params) {
      banner.add(params).then(res => {
        console.log('数据：', res)
        notification.success({
          message: '消息',
          description: '新增成功！',
        })
        let currentPage = this.$parent.pagination.current
        let pageSize = this.$parent.pagination.pageSize
        this.$parent.getBannerList({ currentPage, pageSize })
        this.visible = false
      })
    },
    //修改
    edit(params) {
      params.id = this.id
      banner.edit(params).then(res => {
        console.log('数据：', res)
        notification.success({
          message: '消息',
          description: '修改成功！',
        })
        let currentPage = this.$parent.pagination.current
        let pageSize = this.$parent.pagination.pageSize
        this.$parent.getBannerList({ currentPage, pageSize })
        this.visible = false
      })
    },
    //获取详情
    getDetail(id) {
      banner.detail({ id }).then(res => {
        // console.log(res);
        let banner = res.data
        this.clickType = banner.clickType
        console.log(banner)
        let detail = {
          title: banner.title,
          // imgUrl: banner.imgUrl,
          h5Url: banner.h5Url,
          clickType: banner.clickType,
          clickParam: banner.clickParam,
          priority: banner.priority,
        }
        //代理
        if (this.roleId == 1) {
          if (banner.schoolId) {
            this.showType = 2
            detail.schoolId = {
              key: banner.schoolId + '',
              label: banner.schoolName,
            }
          } else {
            this.showType = 1
          }
        }
        this.imgUrl = res.data.imgUrl
        this.$refs.imgUrl.imageUrl = res.data.imgUrl
        setTimeout(() => {
          this.form.setFieldsValue(detail)
        }, 100)
      })
    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    uploadSuccess(e) {
      console.log('e', e)
      this.bannerHelpTxt = ''
      this.imgUrl = e ? e : ''
    },
    //返回
    back() {
      this.$router.back()
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' })
  },
  created() {
    this.$store.dispatch('getUserInfo').then(res => {
      console.log('userInfo', res)
      console.log('roleId', res.accRole.id)
      this.userInfo = res
      this.roleId = res.accRole.id
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 50px 20px 30px;
  background: white;
  margin: 20px auto;
}
.ap-form {
  width: 400px;
}
.form-oper {
  text-align: center;
  button {
    margin: 0px 5px;
  }
}
</style>
